import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NavigationItem } from '../../shared/models/navigation-item';

@Injectable()
export class NavigationService {

  private _navigationStack: NavigationItem[] = [];
  private _subject: Subject<NavigationItem> = new Subject<NavigationItem>();

  public get change(): Observable<NavigationItem> {
    return this._subject;
  }

  public pushItem(route: NavigationItem): void {
    this._navigationStack.push(route);
    this._subject.next(route);
  }

  public popItem(): NavigationItem {
    const route = this._navigationStack.pop();
    this._subject.next(route);
    return route;
  }

  public clearStack(): void {
    this._navigationStack = [];
    //this._subject.next(route);
  }

}
